import styled from "styled-components";

export const Div = styled.div`
  ${(props) =>
    props.theme.apply(["tablet", "desktop", "screen"], (breakpoint: string) => {
      return `
      margin-bottom: ${props.theme.spacePx(breakpoint, 5)};

        `;
    })}
`;


export const Sidebar = ({ children }: { children: React.ReactNode }) => {
  return (
    <Div>
      {children}
    </Div>
  );
};

export default Sidebar;
